export enum NotificationType {
  Success = 'is-success',
  Warning = 'is-warning',
  Info = 'is-info',
  Danger = 'is-danger',
}
